import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser'; 

@Component({
  selector: 'app-privacy_policy',
  templateUrl: './privacy_policy.component.html',
  styleUrls: ['./privacy_policy.component.css']
})
export class PrivacyPolicyComponent implements OnInit {

  constructor(
    private titleService: Title
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle("Personal Data Protection Notice | Line Clear Express")
  }

}
